import { AppBar, Toolbar } from "@material-ui/core";
import Logo from "images/logo-blue-gray-side.png";
import React from "react";
import { Link } from "react-router-dom";
import "./navbar.css.scss";

const BaseNavbar = ({ children }) => {
  return (
    <AppBar position="static" style={{ background: "#FFF" }}>
      <Toolbar>
        <Link to="/">
          <img src={Logo} className="nb-logo" />
        </Link>

        {children}
      </Toolbar>
    </AppBar>
  );
};

export default BaseNavbar;
